import React from 'react';

import {getTenantLevelInventorySettingsURL} from 'inventory/InventoryConstants';
import {getTenantLevelLabelPrintingSettingsURL} from 'label-printing/LabelPrintingConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import EmptySidebarIcon from './EmptySidebarIcon';
import {Section} from './SidebarConstants';
import SidebarItem from './SidebarItem';

interface InventorySettingsProps {
  section: Section;
}

export default function InventorySettings(props: InventorySettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Inventory Settings</div>
      <SidebarItem
        active={props.section === Section.TENANT_LEVEL_INVENTORY_SETTINGS}
        icon={<EmptySidebarIcon />}
        name="General"
        link={getTenantLevelInventorySettingsURL()}
      />
      <SidebarItem
        active={props.section === Section.TENANT_LEVEL_LABEL_PRINTING_SETTINGS}
        icon={<BenchlingIcon className="result-icon" icon="format-print" />}
        name="Label printing"
        link={getTenantLevelLabelPrintingSettingsURL()}
      />
    </div>
  );
}
